import React, { useState, useEffect } from 'react';
import TemplateCard from './TemplateCard';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../utils/axiosInstance';

function TemplatesRow({ title, templates }) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [liked, setLiked] = useState({});
  const navigate = useNavigate();

  const handleViewClick = (id) => {
    navigate(`/template/${id}`);
  };

  const toggleLike = (id) => {
    const currentLikedState = liked[id] || false;

    
    const newLikedState = !currentLikedState;

    if (newLikedState) {
      saveTemplate(id);
    } else {
      unsaveTemplate(id);
    }

    setLiked((prevState) => ({
      ...prevState,
      [id]: newLikedState,
    }));

    return newLikedState
  };


  const saveTemplate = (template_id) => {
    axiosInstance.post(`/users/templatesSaved/${template_id}`)
  }

  const unsaveTemplate = (template_id) => {
    axiosInstance.delete(`/users/templatesSaved/${template_id}`)
  }

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (templates.length > 0) {
      const initialLiked = {};
      templates.forEach((template) => {
        initialLiked[template._id] = template.templateSaved;
      });

      setLiked(initialLiked);
    }
  }, [templates]);


  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: windowWidth > 768 ? 'repeat(4, 1fr)' : 'repeat(1, 1fr)', // 3 columns for larger screens, 1 for smaller
    gap: '20px',
    justifyItems: 'center',
  };

  const colors = ['deeppink', 'lightblue', 'lightgreen'];

  return (
    <div>
      
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <div style={gridStyle}>
          {templates?.map((template, index) => (
            <TemplateCard
              key={index}
              title={template.title}
              color={colors[index % colors.length]} 
              onLike={() => toggleLike(template._id)}
              liked={liked[template._id] || false}
              onViewClick={() => handleViewClick(template._id)}
              saves={template.savedCount || 0}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default TemplatesRow;
